import {Box, FormControlLabel, InputLabel, Switch, Tooltip, Typography} from '@mui/material';
import {memo} from 'react';
import {useTheme} from '@mui/material/styles';

const MhdSwitch= ({ label, value, override, warning, error, onChange, disabled }) => {
  const theme = useTheme()
  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      sx={{ height: '100%' }}
    >
      <InputLabel variant={error ? 'error' : 'primary'}>
        {label}
      </InputLabel>
      <Tooltip
        title={warning} arrow
        componentsProps={{
          tooltip: {sx: {backgroundColor: theme.palette.error.main, color: 'white'}},
          arrow: {sx: {color: theme.palette.error.main}},
        }}
      >
      <FormControlLabel
        control={
          <Switch
            size={'small'}
            checked={override !== undefined ? !!override : !!value}
            onChange={(e) => onChange(e.target.checked)}
            disabled={disabled}
          />
        }
       label={''}/>
      </Tooltip>
      {(override !== undefined) &&
        <Typography variant='caption' color={'error'}>
          Modified: {override ? 'Set to True' : 'Set to False'}
        </Typography>
      }
    </Box>
  );
};

export default memo(MhdSwitch);